import React, { useContext, useEffect } from "react";
import { AppContext } from "../../components/States/AppContext";
import { Link } from "react-router-dom";

//styles
import { ImgSpO, SpOTimestamp } from "./Spo2Button.elements";

//  images
import spo2continuous from "../../img/numeric/spo2/SpO2-continuous.gif";
import spo2OffDefault from "../../img/numeric/spo2/spo2-off.png";
import spo2StartInitiate from "../../img/numeric/spo2/SpO2-start-initiate.gif";
import spo2StartTimestamp from "../../img/numeric/spo2/SpO2-start-timestamp.png";

const Spo2Button = ({ landscape, setting }) => {
  const { state, setState } = useContext(AppContext);

  useEffect(() => {
    if (state.initiateSpo2start) {
      const timeoutId = setTimeout(() => {
        setState((prevState) => ({
          ...prevState,
          spoStart: true,
          initiateSpo2start: false,
          spoTimestamp: new Date(),
        }));
      }, 2500);

      return () => clearTimeout(timeoutId);
    }
  }, [state.initiateSpo2start]);

  const hours = state.spoTimestamp.getHours();
  const minutes = state.spoTimestamp.getMinutes();

  const formattedTime = `${
    hours === 0 ? 12 : hours > 12 ? hours - 12 : hours
  }:${minutes < 10 ? "0" : ""}${minutes}`;

  return (
    <>
      <Link to="/settings/spo2">
        {state.spoContinuous ? (
          <ImgSpO src={spo2continuous} />
        ) : state.initiateSpo2start ? (
          <ImgSpO src={spo2StartInitiate} />
        ) : state.spoStart ? (
          <>
            <div style={{ position: "relative" }}>
              <ImgSpO src={spo2StartTimestamp} key={Date.now()} />
              <SpOTimestamp landscape={landscape} setting={setting}>
                {formattedTime}
              </SpOTimestamp>
            </div>
          </>
        ) : (
          <ImgSpO src={spo2OffDefault} />
        )}
      </Link>
    </>
  );
};

export default Spo2Button;
